export default __webpack_public_path__ + "static/Average May temp 2020-15ec79a6ea576901e8a9ef66543783cb.png";